import { render, staticRenderFns } from "./FormatBlock.vue?vue&type=template&id=17d9559c&scoped=true&"
import script from "./FormatBlock.vue?vue&type=script&lang=js&"
export * from "./FormatBlock.vue?vue&type=script&lang=js&"
import style0 from "./FormatBlock.vue?vue&type=style&index=0&id=17d9559c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d9559c",
  null
  
)

export default component.exports